import {setupBasicSuggestSelect} from '../../../common/suggests';
import {setupInvoiceProvider} from '../../../common/invoiceProvider';

// 個人設定
$(() => {
    // 請求元口座情報
    if (document.getElementById('biller-setting') != null) {
        setupBasicSuggestSelect('.js-bank-name', '/partner/findBank', '銀行名を入力', null, null, null);
		$('.js-bank-name').on('change', function(e) {
            let selectedBank = $('.js-bank-name option:selected').val();
            if (isNaN(selectedBank)) {
                selectedBank = '';
            }
            $('.bank-code').text(selectedBank);
            $('.js-branch-name').val(null).trigger('change');
        });
        setupBasicSuggestSelect('.js-branch-name', '/partner/findBranch', '支店名を入力', branchParamaterFilter, null, null);
		$('.js-branch-name').on('change', function(e) {
            let selectedBranch = $('.js-branch-name option:selected').val();
            if (isNaN(selectedBranch)) {
                selectedBranch = '';
            }
            $('.branch-code').text(selectedBranch);
        });
        $('.js-biller-setting').on('click', function(e) {
            $('#biller-setting_modal').modal('show');
        });
        $('.biller-setting-exec').on('click', function(e) {
            $('#add_biller').submit();
        });
        $('.js-biller-main-setting').on('click', function(e) {
            $('#biller-main-setting_modal').modal('show');
            let id = $(this).data('id');
            $('.js-biller-setting').prop('href', '/partner/setting/defaultBiller/' + id);
            $('.js-biller-setting-all-change').prop('href', '/partner/setting/defaultBillerAllChange/' + id);
        });
        $('.js-biller-modal-close').click(function(){
            $('#biller-main-setting_modal').modal('hide');
        });

        // インボイス情報
        setupInvoiceProvider();

        /**
         * 口座名義をフォーマットする
         * - 全角のカナ＋許容される記号を半角に変換
         * - 半角小文字カナを半角大文字カナに変換
         *
         * @param {string} accountName
         * @returns {string}
         */
        function formatAccountName (accountName) {
            const kanaMap = {
                "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
                "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
                "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
                "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
                "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
                "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
                "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
                "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
                "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
                "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
                "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
                "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
                "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
                "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
                "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
                "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
                "ァ": "ｱ", "ィ": "ｲ", "ゥ": "ｳ", "ェ": "ｴ", "ォ": "ｵ",
                "ッ": "ﾂ", "ャ": "ﾔ", "ュ": "ﾕ", "ョ": "ﾖ",
                "（": "(", "）": ")", "・": "･", "ー": "ｰ", "／": "/", "　": " "
            };
            const regexp = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
            return accountName.replace(regexp, function (match) {
                return kanaMap[match];
            });
        }
        // 表示時に口座名義をフォーマット
        $('.account-name').each(function () {
            $(this).val(formatAccountName($(this).val()));
        });
        // フォーカスアウト時に口座名義をフォーマット
        $('.account-name').on('focusout', function () {
            $(this).val(formatAccountName($(this).val()));
        });
    }

    // slack連携
    if (document.getElementById('partner-slack-integration') != null) {
        $('#common_modal').on('show.bs.modal', function (event) {
            $('.modal-exec').click(function(event) {
                let anchor = $('.js-revoke-slack-integration');
                anchor.addClass('disabled');
                $('#common_modal').modal('hide');
                window.location = anchor.attr('href');
            });
        })
    }

    $('[data-toggle="tooltip"]').tooltip();

    // インボイス情報更新
    document.querySelectorAll('.update-register-number').forEach(button => {
        button.addEventListener('click', function () {
            const updateInvoiceProviderUrl = this.dataset.url;
            const billerSettingId = this.dataset.id;
            const prefixedRegisterNumber = this.dataset.number;

            updateRegisterNumber(updateInvoiceProviderUrl, billerSettingId, prefixedRegisterNumber, this);
        });
    });

    function updateRegisterNumber(updateInvoiceProviderUrl, billerSettingId, prefixedRegisterNumber, button) {

        if (!prefixedRegisterNumber) {
            displayErrorMessage(button, "インボイス情報の更新に失敗しました。");
            return;
        }

        const registerNumber = formatRegisterNumber(prefixedRegisterNumber);

        if (!registerNumber) {
            displayErrorMessage(button, "インボイス情報の更新に失敗しました。");
            return;
        }

        // フォームを動的に作成
        const form = createForm(updateInvoiceProviderUrl, registerNumber, billerSettingId);

        document.body.appendChild(form);
        form.submit();
    }

    function displayErrorMessage(button, message) {
        const tdElement = button.closest('td');
        if (!tdElement) {
            return;
        }

        const errorMessageElement = tdElement.querySelector('.error-message');
        if (!errorMessageElement) {
            return;
        }

        errorMessageElement.textContent = message;
        errorMessageElement.style.display = 'block';
    }

    function formatRegisterNumber(prefixedRegisterNumber) {
        // 先頭のTを除外し、数字13桁を抽出
        const cleanedNumber = prefixedRegisterNumber.replace(/^T/, '');
        const match = cleanedNumber.match(/\d{13}/);

        return match ? match[0] : null;
    }

    function createForm(updateInvoiceProviderUrl, registerNumber, billerSettingId) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = updateInvoiceProviderUrl;

        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = '_token';
        csrfInput.value = csrfToken;
        form.appendChild(csrfInput);

        const registerNumberInput = document.createElement('input');
        registerNumberInput.type = 'hidden';
        registerNumberInput.name = 'register_number';
        registerNumberInput.value = registerNumber;
        form.appendChild(registerNumberInput);

        const billerSettingIdInput = document.createElement('input');
        billerSettingIdInput.type = 'hidden';
        billerSettingIdInput.name = 'id';
        billerSettingIdInput.value = billerSettingId;
        form.appendChild(billerSettingIdInput);

        return form;
    }
});

// 支店名用パラメータフィルター
function branchParamaterFilter(params) {
    let selectedBank = $('.js-bank-name option:selected').val();
	var query = {
		search: params.term,
		code: selectedBank,
	}
	return query;
}
